<template>
  <AppViewContainer>
    <ListWebhookEvents />
  </AppViewContainer>
</template>

<script>
import AppViewContainer from '../components/UI/AppViewContainer.vue'
import ListWebhookEvents from '../components/webhookEvent/ListWebhookEvents.vue'

export default {
  name: 'WebhookEventsView',
  components: { AppViewContainer, ListWebhookEvents }
}
</script>
